import React, { memo, useCallback, useState } from 'react';
import { connect } from 'react-redux';

import connectOptions, { mergeProps } from '../../utils/connectOptions';
import Popups from '../../components/Popup';

const ConfirmPopupContainer = ({ popup, children }) => {
  const [isWaiting, setIsWaiting] = useState(false);

  const handleOk = useCallback(() => {
    const onOk = popup.getIn(['props', 'onOk'], () => {});

    setIsWaiting(true);
    onOk();
  }, [popup]);

  const handleCancel = useCallback(() => {
    const onCancel = popup.getIn(['props', 'onCancel'], () => {});

    onCancel();
  }, [popup]);

  const getMessage = useCallback(() => {
    const message = popup.getIn(['props', 'message']);

    if (typeof message === 'function') return message();

    return message;
  }, [popup]);

  const extra = popup.toJS().props;

  if (popup.getIn(['props', 'yes'])) extra.yes = popup.getIn(['props', 'yes']);
  if (popup.getIn(['props', 'no'])) extra.no = popup.getIn(['props', 'no']);

  return (
    <div>
      <Popups.ConfirmPopup
        {...extra}
        message={getMessage()}
        onCancel={handleCancel}
        onOk={handleOk}
        waiting={isWaiting}
      />
      {children}
    </div>
  );
};

function mapStateToProps(state, props) {
  return {
    ...props,
  };
}

export { ConfirmPopupContainer };

export default connect(mapStateToProps, {}, mergeProps, connectOptions)(memo(ConfirmPopupContainer));
